export default __webpack_public_path__ + "static/uniswap-3a3d672cf3a83a9ff10158cde7660943.png";